import type { VisualizationData } from '../../../../types'

export const Visualization = ({ visualization }: { visualization: VisualizationData }) => {
  return <iframe src={visualization.url} className="mt-2 min-h-[485px] w-full rounded-xl" />
}
